export default function R_Syntax() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Syntax Component</h1>
      <p>This is the R_Syntax tutorial section.</p>
    </div>
  );
}
